import { useTranslation } from "react-i18next"
import { Button, Form, Row } from 'react-bootstrap'

export default function FormProduct({submit, isNew, inputChange, state}) {
    const { t } = useTranslation()

    return (
        <>
            <Form onSubmit={submit}>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('products.name')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='name' 
                        value={state.name || state.nameEdit ||  ''}
                        placeholder={t('products.name')}
                        onChange={inputChange}
                        required
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label className="form-label mt-3">{t('products.matter')}</Form.Label>
                    <Form.Control className="form-control"
                        type='text'
                        name='matter' 
                        value={state.matter || state.matterEdit ||  ''}
                        placeholder={t('products.matter')}
                        onChange={inputChange}
                    />
                </Form.Group>
                <Row className="text-left custom-card-header-list">
                    {
                        isNew === false
                        ?
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('products.update')}</Button>
                        :
                        <Button className="btn btn-secondary my-2 mx-auto" type="submit"><i className="fas fa-save"></i> {t('products.new')}</Button>
                    }
                </Row>
            </Form>
        </>
    )    
}
